import React, { memo } from 'react';
import { BUBBLE_TEXTS } from 'components/pages/Anatomy/data';
import styles from './index.module.scss';
import { ParallaxBlock } from '../../ui/ParallaxBlock';
import { Bubble } from '../../ui/Bubble';

export const PhysicalActivitySection = memo(function PhysicalActivitySection() {
  return (
    <ParallaxBlock className={styles.root}>
      <Bubble
        classNameRoot={styles.bubbleRoot}
        color="blue"
        shape="fourAngles"
        text={BUBBLE_TEXTS.physhicalActivity}
      />
      <div className={styles.swimmer} />
    </ParallaxBlock>
  );
});
